import { MapPinIcon } from '@heroicons/react/24/outline';
import { createColumnHelper } from '@tanstack/react-table';
import { DateTime } from 'luxon';

import { DataGrid } from 'src/common/DataGrid';
import { EmptyState } from 'src/common/primitives/EmptyState/EmptyState';

import { LocationWithColor } from './EventDeviceLogMapView';

const columnHelper = createColumnHelper<LocationWithColor>();

const columns = [
  columnHelper.accessor('location_log_entry.device_timestamp', {
    header: 'Time',
    cell: ({ row }) => {
      const date = DateTime.fromISO(
        row.original.location_log_entry.device_timestamp
      );
      return date.toLocaleString(DateTime.DATETIME_SHORT);
    },
    meta: {
      enableHeaderMenu: false,
    },
  }),
  columnHelper.accessor('location_log_entry.longitude', {
    header: 'Lng',
    cell: ({ row }) => row.original.location_log_entry.longitude.toPrecision(5),
    meta: {
      enableHeaderMenu: false,
    },
  }),
  columnHelper.accessor('location_log_entry.latitude', {
    header: 'Lat',
    cell: ({ row }) => row.original.location_log_entry.latitude.toPrecision(5),
    meta: {
      enableHeaderMenu: false,
    },
  }),
  columnHelper.accessor('location_log_entry.battery_level', {
    header: 'Battery',
    cell: ({ row }) => {
      const level = row.original.location_log_entry.battery_level;
      if (level >= 0 && level <= 1) {
        return `${Math.round(level * 100)}%`;
      }
      return '?'; // When battery level is -1 (unknown)
    },
    meta: {
      enableHeaderMenu: false,
    },
  }),
  columnHelper.accessor('location_log_entry.battery_is_charging', {
    header: 'Charging',
    cell: ({ row }) => {
      return row.original.location_log_entry.battery_is_charging ? '✓' : '✗';
    },
    meta: {
      enableHeaderMenu: false,
    },
  }),
  columnHelper.accessor('color', {
    header: '',
    cell: ({ row }) => {
      return (
        <div
          className="h-4 w-4 rounded-full"
          style={{ backgroundColor: row.original.color }}
        />
      );
    },
    meta: {
      enableHeaderMenu: false,
    },
  }),
];

export function EventDeviceLogDataGrid({
  locations,
  totalCount,
}: {
  locations: LocationWithColor[];
  totalCount: number;
}) {
  return (
    <DataGrid
      tableId="event-device-log-table"
      columns={columns}
      data={locations}
      emptyState={
        <EmptyState
          Icon={<MapPinIcon className="h-6 w-6" />}
          entityName="Event Device Log"
          description="No event device log found for the selected trip."
        />
      }
    />
  );
}
